import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect, useState } from 'react';
import { chooseProfileFilter } from "../../helpers/chooseProfileFilter";
import sleep from "sleep-promise";

function Form() {
    const profileFilter = chooseProfileFilter()

    const hiddenValues = {}

    if (profileFilter.gci_company_id) {
        hiddenValues.gci_company_id = profileFilter.gci_company_id
    }

    const getOrganizationType = async (values) => {
        if (profileFilter.organization_type) {
            return profileFilter.organization_type;
        }
        const companyId = values?.gci_company_id;
        if (!companyId) return 'default';
        const company = await Fetch.post(`${config.endpoints.backend}gci/companies/getById`, { id: companyId });
        return company?.organization_type || 'default';
    };

    const { id } = useParams();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}gci/bank-accounts/save`,
        endpointGetById: `${endpointBackend}gci/bank-accounts/getById`,
        endpointGetAllVentures: `${endpointBackend}gci/ventures/getall`,
        endpointGetAllBanks: `${endpointBackend}gci/banks/getall`,
        endpointGetAllBankAccountTypes: `${endpointBackend}gci/bank-account-types/getall`,
        endpointGetAllCompanies: `${endpointBackend}gci/companies/getall`,
        urlGoBack: `/gci/bank-accounts/list`,
        pathView: `/gci/bank-accounts/view`
    }

    const labels = {
        labelTitleAdd: "Nova Conta Bancária",
        labelTitleEdit: "Editar Conta Bancária",
        labelTitleView: 'Visualizar Conta Bancária'
    }

    const getForm = (values, organizationType = 'default') => {
        const isDefaultOrganizationType = organizationType === 'default';

        let form = {
            hiddenValues,
            fields: [
                !profileFilter.gci_company_id ? {
                    name: 'gci_company_id',
                    type: 'select',
                    label: 'Empresa',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllCompanies,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    handleChange: async (element, field, values) => {
                        values.gci_venture_id = null;
                        const organizationType = await getOrganizationType(values);
                        let form = getForm(values, organizationType);
                        form.fields[1].autoFocus = true;
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    columnSize: 12
                } : {},
                isDefaultOrganizationType ? {
                    name: 'ventures',
                    type: 'multiinput',
                    label: 'Empreendimentos',
                    sortBy: 'index',
                    form: [
                        {
                            name: 'gci_venture_id',
                            type: 'select',
                            label: 'Empreendimento',
                            options: [],
                            optionsEndpoint: {
                                endpoint: paths.endpointGetAllVentures,
                                label: 'enterprise_name',
                                value: 'id',
                                params: {
                                    filter: {
                                        ...profileFilter,
                                        gci_company_id: values.gci_company_id,
                                        hasAccount: 'dont-have',
                                        // adicionar filtro para mostrar o empreendimento
                                        // atual do select
                                        orIdIn: values.venturesIds
                                    }
                                }
                            },
                            validations: {
                                required: true
                            },
                            columnSize: 12
                        }
                    ],
                    validations: {
                        required: true
                    }
                } : {},
                {
                    name: 'gci_bank_id',
                    type: 'select',
                    label: 'Banco',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllBanks,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 6
                },
                {
                    name: 'gci_bank_account_type_id',
                    type: 'select',
                    label: 'Tipo de Conta',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllBankAccountTypes,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 6
                },
                {
                    name: 'name',
                    type: 'text',
                    label: 'Título da Conta',
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                },
                {
                    name: 'agency',
                    type: 'text',
                    label: 'Agência',
                    validations: {
                        required: true
                    },
                    columnSize: 3,
                    maxLength: 4
                },
                {
                    name: 'agency_digit',
                    type: 'text',
                    label: 'Agência - Dígito',
                    validations: {
                        required: false
                    },
                    columnSize: 3,
                    maxLength: 1
                },
                {
                    name: 'account',
                    type: 'text',
                    label: 'Conta',
                    validations: {
                        required: true
                    },
                    columnSize: 3,
                    maxLength: 11
                },
                {
                    name: 'account_digit',
                    type: 'text',
                    label: 'Conta - Dígito',
                    validations: {
                        required: true
                    },
                    columnSize: 3,
                    maxLength: 1
                },
                {
                    name: 'acctid',
                    type: 'text',
                    label: 'ACCTID (identificador da conta no arquivo OFX)',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'address',
                    type: 'address',
                    label: 'Endereço',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'phones',
                    type: 'multiinput',
                    label: 'Telefones',
                    sortBy: 'index',
                    form: [
                        {
                            label: 'Telefone',
                            type: 'phone',
                            name: 'phone',
                            validations: {
                                required: false
                            }
                        }
                    ],
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'manager',
                    type: 'text',
                    label: 'Gerente',
                    validations: {
                        required: false
                    },
                    columnSize: 6
                },
                {
                    name: 'contact',
                    type: 'text',
                    label: 'Contato',
                    validations: {
                        required: false
                    },
                    columnSize: 6
                }
            ],
            ...paths,
            ...labels,
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })

                if (values.ventures) {
                    const ventures = [];
                    values.ventures.map(venture => {
                        ventures.push(venture.gci_venture_id.value)
                    })
                    
                    values.venturesIds = ventures
                }
            }

            console.log(values)

            const organizationType = await getOrganizationType(values);
            const form = getForm(values, organizationType);

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
